export default "__VITE_ASSET__Det8_hS1__"